import { SET_ALERT, REMOVE_ALERT, SET_ALERT_EDIT_BOOKING, REMOVE_ALERT_EDIT_BOOKING } from "../actions/types";
const initialState = [];

export default function foo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ALERT:
      return [...state, payload];
    case REMOVE_ALERT:
      return state.filter((alert) => alert.id !== payload);
    case SET_ALERT_EDIT_BOOKING:
      return payload;
    case REMOVE_ALERT_EDIT_BOOKING:
      return {};
    default:
      return state;
  }
}
